import { Link, useLocation } from '@remix-run/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faList, faSackDollar, faQuestionCircle, faHeart, faChartSimple, faPeopleRoof, faChartDiagram, faNewspaper, faListCheck, faTableCells, faBuildingColumns, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import LinkButton from './LinkButton';
import { useState } from 'react';
import TickerSearchModal from './TickerSearchModal';
import MainAuthModal from '../components/authModals/App';

const SignedOutSideNavbar = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
    const location = useLocation();
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [tickerSearchModalMode, setTickerSearchModalMode] = useState<"financials" | "snapshots" | "insider-activity" | "news" | null>(null);
    const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
    return (
        <nav id="signed-out-side-navbar" className="hidden lg:flex flex-col fixed left-0 top-0 h-screen w-[256px] bg-background-dark border-r border-gray-200 pt-20 z-30">
            <div className="absolute top-4 left-4">
                <div className="flex flex-1">
                    <a href="/" className="-m-1.5 p-1.5 flex items-end">
                        <span className="sr-only">MarketDataFyi</span>
                        <img
                            alt="MarketDataFyi"
                            src="/mdfyi-logo.png"
                            className="h-10 w-auto"
                        />
                        <span className="ml-2 text-[11px] font-normal text-gray-800 opacity-75">
                            Beta!
                        </span>
                    </a>
                </div>
            </div>
            <div className="flex flex-col mt-16">
                <Link
                    to="/screener"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/screener' || location.pathname === '/'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faSliders} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Screener</span>
                </Link>
                {/* <Link
                    to="/stocks-grid"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
                    ${location.pathname === '/stocks-grid'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faTableCells} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Portfolio Grid</span>
                </Link> */}
                <Link
                    to="/evaluation-checklist"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/evaluation-checklist'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faListCheck} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Evaluation Checklist</span>
                </Link>
                <div
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        if (isAuthenticated) {
                            setTickerSearchModalMode("financials");
                            setShowSearchModal(true);
                        } else {
                            setIsSignInModalOpen(true);
                        }
                    }}
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative cursor-pointer
                        ${location.pathname === '/visualize-financials'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faChartSimple} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Financials</span>
                </div>
                <div
                    role="button"
                    tabIndex={1}
                    onClick={() => {
                        if (isAuthenticated) {
                            setTickerSearchModalMode("snapshots");
                            setShowSearchModal(true);
                        } else {
                            setIsSignInModalOpen(true);
                        }
                    }}
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/insider-activity'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faChartDiagram} className="text-xl mr-3 text-black -rotate-90" />
                    <span className="text-sm">Earnings Snapshots</span>
                </div>
                <div
                    role="button"
                    tabIndex={2}
                    onClick={() => {
                        if (isAuthenticated) {
                            setTickerSearchModalMode("insider-activity");
                            setShowSearchModal(true);
                        } else {
                            setIsSignInModalOpen(true);
                        }
                    }}
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/insider-activity'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faPeopleRoof} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Insider Activity</span>
                </div>
                <div
                    role="button"
                    tabIndex={3}
                    onClick={() => {
                        if (isAuthenticated) {
                            setTickerSearchModalMode("news");
                            setShowSearchModal(true);
                        } else {
                            setIsSignInModalOpen(true);
                        }
                    }}
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/insider-activity'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faNewspaper} className="text-xl mr-3 text-black" />
                    <span className="text-sm">News Sentiment</span>
                </div>
                <Link
                    to="/features"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/features'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faList} className="text-xl mr-3 text-black" />
                    <span className="text-sm">Features Demos</span>
                </Link>
                {/* <Link
                    to="/pricing"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/pricing'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faSackDollar} className="h-5 w-5 mr-3 text-black" />
                    <span className="text-sm">Pricing</span>
                </Link> */}
                <Link
                    to="/faqs"
                    className={`flex items-center px-4 py-3 transition-all duration-200 relative
            ${location.pathname === '/faqs'
                            ? 'text-gray-900 border-r-4 border-r-black font-bold'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                        }`}
                >
                    <FontAwesomeIcon icon={faQuestionCircle} className="text-xl mr-3 text-black" />
                    <span className="text-sm">FAQs</span>
                </Link>
            </div>

            {/* Sign In and Sign Up Buttons */}
            <div className="mt-6 pl-4 pr-20 space-y-5">
                <LinkButton
                    href="/sign-in"
                    type="outline"
                    size="small"
                    fullWidth
                >
                    Sign In
                </LinkButton>
                <LinkButton
                    href="/sign-up"
                    type="primary"
                    size="small"
                    fullWidth
                >
                    Get Started
                </LinkButton>
            </div>

            {/* Ticker Search Modal */}
            {showSearchModal && (
                <TickerSearchModal showSearchModal={showSearchModal} setShowSearchModal={setShowSearchModal} mode={tickerSearchModalMode} />
            )}
            {
                isSignInModalOpen &&
                <MainAuthModal
                    isOpen={isSignInModalOpen}
                    onClose={setIsSignInModalOpen}
                    query={""}
                />
            }
        </nav>
    );
};

export default SignedOutSideNavbar; 